import React from 'react';

export interface CardProps {
  /** Visual density. "comfortable" is the default for most pages. */
  padding?: 'comfortable' | 'compact' | 'flush';
  /** Drop the shadow for cards inside other cards. */
  flat?: boolean;
  className?: string;
  style?: React.CSSProperties;
  children: React.ReactNode;
}

const PADDING = {
  comfortable: 'var(--vc-space-5)',
  compact:     'var(--vc-space-4)',
  flush:       '0',
} as const;

/**
 * Base white-surface block. Everything that "looks like a card" in the app should
 * be this — gives a single point to retune corner radius, shadow, padding.
 */
export const Card: React.FC<CardProps> = ({
  padding = 'comfortable',
  flat = false,
  className,
  style,
  children,
}) => {
  return (
    <div
      className={['vc-card', flat ? 'vc-card--flat' : '', className]
        .filter(Boolean)
        .join(' ')}
      style={{ padding: PADDING[padding], ...style }}
    >
      {children}
    </div>
  );
};
